import { DEFAULT_COMPONENT } from 'config/components/mobile2'

const BASIC_CONTENT = [
  {
    meta: {
      component: 'banner',
    },
    styles: {
      color: '#000',
    },
    content: {
      image: 'https://demo-system-next.s3.amazonaws.com/assets/luma/banners/AdobeStock_570499457.jpg',
      title: 'Hello World!',
      opacity: 0,
      subtitle: 'Lorem ipsum dolor sit amet',
      showButton: true,
      buttonLabel: 'Click me',
      imageResize: 'cover',
      titleVariant: 'titleLarge',
      buttonVariant: 'contained',
      subtitleVariant: 'titleLarge',
      contentAlignment: 'right',
      verticalAlignment: 'top',
      horizontalAlignment: 'right',
    },
  },
  {
    meta: {
      component: 'title',
    },
    styles: {},
    content: {
      size: 'medium',
      text: 'Lorem ipsum',
      weight: 'bold',
      textAlignment: 'left',
    },
  },
  {
    meta: {
      component: 'list',
    },
    styles: {
      gap: 12,
      marginHorizontal: '12',
    },
    content: {
      items: [],
      limit: 5,
      filter: '',
      layout: 'horizontal',
      listType: 'productList',
      textColor: '#BBB',
      imageWidth: 120,
      itemHeight: 120,
      itemsInRow: 1,
      itemRenderer: 'stacked',
      filterProperty: 'Category',
      imageResizeMode: 'cover',
      titleFontWeight: 'regular',
      subtitleFontWeight: 'light',
    },
  },
  {
    meta: {
      component: 'title',
    },
    styles: {},
    content: {
      size: 'medium',
      text: 'Lorem ipsum',
      weight: 'bold',
      textAlignment: 'left',
    },
  },
  {
    meta: {
      component: 'list',
    },
    styles: {
      gap: 12,
      marginBottom: '16',
      marginHorizontal: '8',
      color: '#f4f3f3',
    },
    content: {
      items: ['home'],
      layout: 'horizontal',
      listType: 'screenList',
      imageWidth: 130,
      itemHeight: null,
      itemRadius: null,
      itemsInRow: 3,
      itemRenderer: 'overlay',
      filterProperty: 'Category',
      imageResizeMode: 'cover',
    },
  },
  {
    meta: {
      component: 'banner',
    },
    styles: {
      color: '#ffffff',
    },
    content: {
      image: 'https://demo-system-next.s3.amazonaws.com/helium/assets/yoga-eq.jpeg',
      title: 'Lorem ipsum',
      linkTo: 'gear',
      opacity: 0.12,
      subtitle: 'Lorem ipsum dolor sit amet',
      imgHeight: 150,
      showButton: false,
      buttonLabel: '',
      imageResize: 'cover',
      titleVariant: 'titleLarge',
      subtitleVariant: 'titleMedium',
      contentAlignment: 'left',
      verticalAlignment: 'bottom',
      horizontalAlignment: 'left',
    },
  },
]

export const MOBILE_V2 = {
  label: 'MobileV2',
  value: 'mobile-v2',
  channel: 'mobile',
  navigationLimit: 5,
  tabs: ['screens', 'navigation', 'branding', 'integrations', 'profile-viewer', 'products'],
  freeformTemplates: [
    {
      label: 'Empty',
      template: 'FreeformScreen',
      preset: 'empty',
      thumbnail: 'mobile-unknown-2.png',
      content: [],
    },
    {
      label: 'Basic',
      template: 'FreeformScreen',
      preset: 'basic',
      thumbnail: 'mobile-hero-screen.png',
      content: BASIC_CONTENT,
    },
    {
      label: 'Product',
      template: 'FreeformScreen',
      preset: 'product',
      thumbnail: 'mobile-product-screen.png',
      content: [
        {
          meta: {
            component: 'productImage',
          },
          styles: {
            height: 450,
          },
          content: {
            fullWidth: true,
            imageResize: 'cover',
          },
        },
        {
          meta: {
            layout: 'vertical',
            component: 'panel',
            showBorder: false,
            itemsFillWidth: true,
            wrapOverflowing: false,
          },
          styles: {
            gap: 0,
            margin: 8,
            padding: 8,
            alignItems: 'flex-start',
            justifyContent: 'space-between',
          },
          content: [
            {
              meta: {
                component: 'productTitle',
              },
              content: {
                size: 'small',
                weight: 'bold',
                textAlignment: 'left',
              },
            },
            {
              meta: {
                component: 'productPrice',
              },
              content: {},
            },
            {
              meta: {
                component: 'productAddToCartButton',
              },
              styles: {
                marginVertical: '16',
              },
              content: {
                label: 'Add to cart',
                variant: 'contained',
                alignment: 'stretch',
                appearanceVariant: 'text-icon',
              },
            },
            {
              meta: {
                component: 'productDescription',
              },
              content: {},
            },
          ],
        },
      ],
    },
    {
      label: 'Category',
      template: 'FreeformScreen',
      preset: 'category',
      thumbnail: 'mobile-list-screen.png',
      content: [
        {
          meta: {
            component: 'banner',
          },
          styles: {
            color: '#ffffff',
          },
          content: {
            size: 'medium',
            image: 'https://demo-system-next.s3.amazonaws.com/assets/luma/AdobeStock_139100491.jpeg',
            title: 'Category',
            layout: 'full-overlay',
            linkTo: '',
            opacity: 0.1,
            subtitle: 'Lorem ipsum dolor sit amet',
            imageResize: 'cover',
            titleVariant: 'titleLarge',
            subtitleVariant: 'titleMedium',
            contentAlignment: 'left',
            verticalAlignment: 'middle',
            horizontalAlignment: 'left',
          },
        },
        {
          meta: {
            component: 'list',
          },
          content: {
            items: [],
            filter: 'Your category',
            layout: 'vertical/grid',
            listType: 'productList',
            itemsInRow: 1,
            itemRenderer: 'image-text-one-line',
            filterProperty: 'Category',
            titleFontWeight: 'regular',
            subtitleFontWeight: 'light',
          },
        },
      ],
    },
    {
      label: 'User Details',
      template: 'FreeformScreen',
      preset: 'userDetails',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'userDetails',
          },
          content: {
            showLogoutButton: true,
          },
        },
      ],
    },
    {
      label: 'Login',
      template: 'FreeformScreen',
      preset: 'login',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'userLogin',
          },
          content: {
            title: 'Login',
            passwordLabel: 'Password',
            usernameLabel: 'Email',
          },
        },
      ],
    },
    {
      label: 'Registration',
      template: 'FreeformScreen',
      preset: 'registration',
      thumbnail: 'mobile-form-screen.png',
      content: [
        {
          meta: {
            link: 'home',
            component: 'form',
            eventType: 'mobile.registration',
            webhookUrl: '',
            toastMessage: 'Welcome!',
            navigateOnSubmit: '',
          },
          content: [
            {
              meta: {
                component: 'title',
              },
              content: {
                size: 'medium',
                text: 'Create an account',
                weight: 'bold',
                textAlignment: 'center',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.name.firstName',
                label: 'First name',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                placeholder: '',
                defaultValue: '',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.name.lastName',
                label: 'Last name',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                rightIcon: 'lock',
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                placeholder: '',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'personalEmail.address',
                label: 'Email',
                prefill: true,
                inputMode: 'email',
                multiline: false,
                rightIcon: 'lock',
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                placeholder: '',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.mobileNumber',
                label: 'Phone number',
                prefill: true,
                inputMode: 'tel',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.address.street',
                label: 'Street',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: true,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.address.city',
                label: 'City',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'checkboxGroup',
              },
              content: {
                options: [
                  {
                    path: 'person.loyaltyConsent',
                    label: 'I want to join the loyalty program',
                    checkedValue: 'y',
                    uncheckedValue: 'n',
                  },
                ],
                prefill: true,
                variant: 'switch',
              },
            },
            {
              meta: {
                component: 'title',
              },
              content: {
                size: 'medium',
                text: 'Consent for marketing communication',
                weight: 'regular',
                textAlignment: 'left',
              },
            },
            {
              meta: {
                component: 'checkboxGroup',
              },
              styles: {
                gap: 24,
                flexDirection: 'row',
              },
              content: {
                options: [
                  {
                    path: 'profile.consent.email',
                    label: 'Email',
                    checkedValue: 'y',
                    uncheckedValue: 'n',
                  },
                  {
                    path: 'profile.consent.phone',
                    label: 'Push',
                    checkedValue: 'y',
                    uncheckedValue: 'n',
                  },
                  {
                    path: 'profile.consent.sms',
                    label: 'SMS',
                    checkedValue: 'y',
                    uncheckedValue: 'n',
                  },
                ],
                prefill: true,
                variant: 'switch',
              },
            },
          ],
        },
      ],
    },
    {
      label: 'Web View',
      template: 'FreeformScreen',
      preset: 'webView',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'webView',
          },
          content: {
            url: 'https://www.adobe.com',
          },
        },
      ],
    },
    {
      label: 'Cart',
      template: 'FreeformScreen',
      preset: 'cart',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'cartSummary',
          },
          content: {
            label: 'TOTAL',
            message: 'Promo code applied sucessfully',
            totalLabel: 'TOTAL',
            errorMessage: 'Invalid Promo Code',
            promoMessage: 'Promo code applied',
            showDiscount: true,
            discountCodes: [
              {
                label: 'SuperPromo20',
                value: '20%',
              },
              {
                label: 'UltimatePromo30',
                value: '30%',
              },
              {
                label: 'OFF5',
                value: '5%',
              },
            ],
            discountLabel: 'DISCOUNT',
            shippingLabel: 'SHIPPING',
            showPromoCode: true,
            subtotalLabel: 'SUBTOTAL',
            promoCodeLabel: 'PROMO CODE',
            emptyCartMessage: 'Your cart is empty',
            promoErrorMessage: 'Invalid promo code',
            showShippingCharge: true,
            configureDiscountCodes: true,
          },
        },
        {
          meta: {
            layout: 'horizontal',
            component: 'panel',
            showBorder: false,
            itemsAlignment: 'center',
          },
          styles: {
            gap: 16,
            padding: 16,
            alignItems: 'center',
            justifyContent: 'center',
          },
          content: [
            {
              meta: {
                component: 'button',
              },
              content: {
                label: 'Empty cart',
                events: 'emptyCart',
                linkTo: '',
                message: '',
                variant: 'contained-tonal',
                alignment: 'stretch',
              },
            },
            {
              meta: {
                component: 'button',
              },
              content: {
                label: 'Review order',
                events: ' --- ',
                linkTo: 'checkout',
                message: '',
                variant: 'contained',
                alignment: 'stretch',
              },
            },
          ],
        },
      ],
    },
    {
      label: 'Checkout',
      template: 'FreeformScreen',
      preset: 'checkout',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            link: 'review-order',
            formId: 'checkoutForm',
            component: 'form',
            eventType: 'commerce.checkouts',
            webhookUrl: '',
            toastMessage: '',
            submitButtonLabel: 'Checkout',
          },
          content: [
            {
              meta: {
                component: 'title',
              },
              content: {
                size: 'medium',
                text: 'Shipping Details',
                weight: 'bold',
                textAlignment: 'left',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.name.firstName',
                label: 'First name',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                placeholder: '',
                defaultValue: '',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.name.lastName',
                label: 'Last name',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                rightIcon: 'lock',
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                placeholder: '',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'personalEmail.address',
                label: 'Email',
                prefill: true,
                inputMode: 'email',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'person.mobileNumber',
                label: 'Phone Number',
                prefill: true,
                inputMode: 'tel',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'shippingAddress.street1',
                label: 'Street',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: true,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'shippingAddress.city',
                label: 'City',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'shippingAddress.postalCode',
                label: 'Postal Code',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'textField',
              },
              content: {
                mode: 'outlined',
                path: 'shippingAddress.country',
                label: 'Country',
                prefill: true,
                inputMode: 'text',
                multiline: false,
                isPassword: false,
                autoCorrect: false,
                leftElement: 'off',
                rightElement: 'off',
              },
            },
            {
              meta: {
                component: 'title',
              },
              content: {
                size: 'medium',
                text: 'Shipping Method',
                weight: 'bold',
                textAlignment: 'left',
              },
            },
            {
              meta: {
                component: 'radioGroup',
              },
              content: {
                path: 'orderProfile.lastOrderType',
                options: [
                  {
                    label: 'STANDARD SHIPPING - 5-14 BUSINESS DAYS',
                    value: 'STANDARD SHIPPING',
                  },
                  {
                    label: 'GROUND SHIPPING - 3-7 BUSINESS DAYS',
                    value: 'GROUND SHIPPING',
                  },
                  {
                    label: 'PRIORITY SHIPPING - 2 BUSINESS DAYS',
                    value: 'PRIORITY SHIPPING',
                  },
                  {
                    label: 'EXPRESS SHIPPING - 1 BUSINESS DAYS',
                    value: 'EXPRESS SHIPPING',
                  },
                ],
                prefill: true,
              },
            },
            {
              meta: {
                component: 'title',
              },
              content: {
                size: 'medium',
                text: 'Payment Methods',
                weight: 'bold',
                textAlignment: 'left',
              },
            },
            {
              meta: {
                component: 'radioGroup',
              },
              content: {
                path: 'orderProfile.lastOrderPaymentMethod',
                options: [
                  {
                    label: 'CREDIT CARD',
                    value: 'credit-card',
                  },
                  {
                    label: 'PAYPAL',
                    value: 'paypal',
                  },
                ],
                prefill: true,
              },
            },
          ],
        },
      ],
    },
    {
      label: 'Review Order',
      template: 'FreeformScreen',
      preset: 'reviewOrder',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'cartSummary',
          },
          content: {
            label: 'TOTAl',
            totalLabel: 'TOTAL',
            showDiscount: true,
            discountCodes: [],
            discountLabel: 'DISCOUNT',
            shippingLabel: 'SHIPPING',
            showPromoCode: true,
            subtotalLabel: 'SUBTOTAL',
            promoCodeLabel: 'PROMO CODE',
            showShippingCharge: 'false',
            configureDiscountCodes: false,
          },
        },
        {
          meta: {
            component: 'button',
          },
          styles: {
            marginTop: '16',
          },
          content: {
            icon: 'cash-check',
            label: 'Confirm',
            events: 'commerce.purchases',
            formId: 'checkoutForm',
            linkTo: 'home',
            message:
              "Thank you for your purchase! Your order has been successfully placed. You'll receive a confirmation email shortly with tracking details. Enjoy your shopping experience!",
            variant: 'contained',
            alignment: 'center',
            customEvent: 'commerce.purchases',
          },
        },
      ],
    },
    {
      label: 'Article',
      template: 'FreeformScreen',
      preset: 'article',
      thumbnail: 'mobile-article-screen.png',
      content: [
        {
          meta: {
            component: 'image',
          },
          styles: {},
          content: {
            image: 'https://demo-system-next.s3.amazonaws.com/assets/luma/blog/1540412484690.jpeg',
            fullWidth: true,
          },
        },
        {
          meta: {
            component: 'title',
          },
          content: {
            size: 'xlarge',
            text: 'Article title',
            weight: 'bold',
          },
        },
        {
          meta: {
            component: 'title',
          },
          content: {
            size: 'large',
            text: 'Lorem ipsum dolor sit amet',
            weight: 'light',
          },
        },
        {
          meta: {
            component: 'htmlText',
          },
          styles: {
            padding: '8',
          },
          content: {
            text: '<p>If you&#39;re new to a sport and find yourself winning unexpectedly, you might be experiencing &quot;beginner&#39;s luck.&quot; But what exactly is it? Often, it’s that surprising initial success when someone is just starting, despite not having much experience.</p><p>So, is beginner&#39;s luck real? While it might feel like pure chance, it could also be a mix of enthusiasm, fresh perspective, and no pressure to perform. Newcomers often approach sports without overthinking, leading to a relaxed mindset that can boost their performance.</p><p>However, as skills grow, the novelty fades, and the game becomes more competitive. The key to success in sports is practice and improvement, so if you’re a beginner, enjoy the lucky streak—but keep training to make it last!</p><p><strong>Tips for Beginners:</strong></p><ul><li>Stay relaxed and enjoy the game.</li><li>Don’t be discouraged if luck runs out—practice makes perfect.</li><li>Focus on improving your skills and techniques over time.</li></ul><p>Beginner’s luck is fun, but consistency is what leads to real success in sports!</p>',
          },
        },
      ],
    },
  ],

  defaultTemplate: {
    name: 'new-screen',
    title: `New Screen`,
    template: 'FreeformScreen',
    preset: 'basic',
    icon: 'home',
    content: BASIC_CONTENT,
  },
  defaultComponent: DEFAULT_COMPONENT,
  unknownTemplate: 'mobile-unknown-2.png',
  triggerTypes: ['beacon'],
  bannerPositionOptions: [],
  navigationAlignmentOptions: [
    { label: 'Left', value: 'left' },
    { label: 'Center', value: 'center', default: true },
    { label: 'Right', value: 'right' },
  ],
  authOptions: [
    { label: 'Always', value: 'always' },
    { label: 'Optional', value: 'optional' },
    { label: 'None', value: 'none' },
  ],
  cartStorageOptions: [
    { label: 'Local', value: 'local', default: true },
    { label: 'AEP', value: 'aep' },
  ],
  displayInboxOptions: [
    { label: 'Hidden', value: 'none' },
    { label: 'Main Navigation', value: 'mainNavigation', default: true },
  ],
}
